export default {
    en: {
        calendarTitle: 'Calendar of Activities',
        description: 'Select the highlighted dates to begin your search. You can only click on the highlighted date',
    },
    id: {
        calendarTitle: 'Kalender Aktivitas',
        description: 'Pilih tanggal yang disorot untuk memulai pencarian. Anda hanya bisa mengklik di tanggal yang disoroti.',
    },
};